import script from "./ManutServicoFrame.vue?vue&type=script&setup=true&lang=js"
export * from "./ManutServicoFrame.vue?vue&type=script&setup=true&lang=js"

import "@/assets/css/layoutFrames.css?vue&type=style&index=0&id=6ed5e4c6&scoped=true&lang=css&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6ed5e4c6"]])

export default __exports__